import { defineMessages } from 'react-intl';

import type { TIERS_WITH_TAGS } from './constants';

export default defineMessages<TIERS_WITH_TAGS>({
  BRONZE: {
    defaultMessage: 'Bronze',
  },

  SILVER: {
    defaultMessage: 'Argent',
  },

  GOLD: {
    defaultMessage: 'Or',
  },
} as const);
